import ContactDetails from '../components/layout/ContactDetails';
import PageHeader from '../components/layout/PageHeader';
import SplitSection from '../components/layout/SplitSection';
import { DIRECTIONS_URL } from '../data/contact';
import usePageTitle from '../hooks/usePageTitle';
import './Locations.css';

export default function Locations() {
  usePageTitle('Locations');

  return (
    <>
      <PageHeader eyebrow="Locations" title="Visit Us" />

      <section className="section clinic" aria-labelledby="clinic-title">
        <div className="container">
          <div className="clinic-card">
            <div className="clinic-card__content">
              <p className="eyebrow">Our clinic</p>
              <h2 id="clinic-title">Phnom Penh</h2>
              <ContactDetails />
            </div>
            <div className="clinic-card__actions">
              <a className="btn btn--primary" href={DIRECTIONS_URL} target="_blank" rel="noreferrer">
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </section>

      <SplitSection
        id="international-network"
        title="Our International Network"
        eyebrow="Beyond Cambodia"
        image="images/location/1.png"
        imageAlt="World map marking our current network locations and next-phase expansion"
        aspectRatio="5 / 4"
        mediaFit="contain"
        tinted
      >
        <p>
          Paw Global Veterinary has cultivated an international network of veterinary professionals
          from Singapore, Indonesia, the Philippines, Dubai, and Abu Dhabi, who serve as clinical
          consultants to our in-house veterinary team. This panel strengthens our standards of care
          by offering diverse clinical expertise and global best practices. Complementing this
          initiative, our veterinary exchange programs provide valuable opportunities for
          professional development—allowing our doctors to gain international exposure, enhance
          their clinical competencies, and better serve the needs of our patients.
        </p>
      </SplitSection>
    </>
  );
}
